import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
  TemplateRef,
} from '@angular/core';
import { Options } from 'ngx-slider-v2';
import { environment } from 'src/environments/environment';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { PMP_PRODUCT_ARRAY, ProductConsts } from './constants';
import { ProductService } from './services/product.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { CartService } from '../cart/services/cart.service';
import { debounceTime, filter, pairwise } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../shared/services/google-analytics.service';
import { SharedConsts } from '../shared/constants';
import { Subject, Subscription } from 'rxjs';
import { BrandModalComponent } from '../shared/components/brand-modal/brand-modal.component';
import { select, Store } from '@ngrx/store';
import { SharedState } from '../shared/store/reducers';
import { getBrands } from '../shared/store/selectors/shared.selectors';
import { HomeService } from '../home/services/home.service';
import { SidebarFiltersComponent } from './components/sidebar-filters/sidebar-filters.component';
import { Console } from 'console';
import { SharedService } from '../shared/services/shared.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  standalone: false,
})
export class ProductComponent implements OnInit {
  private rxjsSimulator: Subject<any> = new Subject();
  private subscription: Subscription = new Subscription();
  getBrandsSubscirber$: Subscription;
  routeChangeSubscriber$: Subscription;
  getProductQuantityUpdateSubscirber$: Subscription;
  watchGlobalDataSubscriber$: Subscription;
  watchMiniCartSubscriber$: Subscription;
  watchCategorySubscriber$: Subscription;
  loading = false;
  show = false;
  filterSelected = 0;
  previous_url = '';
  popupMessage = '';
  bsModalRef: BsModalRef;
  modalRef?: BsModalRef;
  contentLoaded = false;
  productData: any;
  searchText = '';
  categoryTitle = '';
  sortBy = 'short_desc';
  CatSort = '';
  order = 'asc';
  topSeller = '';
  seasonal = '0';
  new = '0';
  range = '';
  rspMin = '';
  rspMax = '';
  topSellerValue = false;
  getAllProductApiSubscribe: any;
  topSellerBeforeapplyValue = '';
  getAllProductAlreadyCall = false;
  pageSize = environment.product_listing_page_size;
  imagePath =
    environment.s3_path + '/' + environment.product_image_folder + '/';
  categoryId: any;
  nextPage = 1;
  productList = [];
  totalProductPages = 1;
  totalProductCount = 0;
  noRecord = true;
  constantsValues = ProductConsts;
  categoryName = 'All';
  filters: any;
  categoryMessage = [];
  selectedPmpProductValue: any = '';
  promotionSelected = '';
  brandSelected = '';
  pmpProduct = [...PMP_PRODUCT_ARRAY];
  filterMobileview = false;
  promotionFilter = [];
  brandFilter = [];
  categoryBrandsListing: Array<any> = [];
  selectedStore: any;
  miniCartDetails: any;
  commonBottonText: any = 'Ok';
  removeProduct = {};
  removeHeading = '';
  page_number = '';
  global_data: any = {};
  isMobile: boolean = false;
  product_for_24_hr: any = {};

  selectedBrandTagName: string;
  selectedPmpTag: string;
  selectedPromotionsTagName: string;
  headerBrandsAlphabet: Array<any> = [];
  appliedFilterObj: any = {};
  isFirstOpen = true;

  @ViewChild('stickyMenu') menuElement: ElementRef;
  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    this.isMobile = (event.target as Window).innerWidth < 991;
    console.log(this.isMobile);
  }
  sticky: boolean = true;
  hasFiltersApplied: boolean = false;
  isFilterReset: boolean = false;
  elementPosition: any;

  sideNavbar: boolean;
  minValue: number = 0.0;
  maxValue: number = 0.0;
  rspMaxValue: any = 0.0;
  rspMinValue: any = 0.0;
  options: Options = {
    floor: 0.0,
    ceil: 5,
    step: 0.5,
  };

  @ViewChild(SidebarFiltersComponent, { static: false })
  sideBarComponent: SidebarFiltersComponent;

  constructor(
    private statePersist: StatePersistService,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private productService: ProductService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private store: Store<SharedState>,
    private cartService: CartService,
    private homeService: HomeService,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    public sharedService: SharedService,
  ) {
    const productData = this.statePersist.getLocalStorage('product_data');

    if (!productData) {
      this.statePersist.setLocalStorage('product_data', { brand_filter: '' });
    }
    else{
      this.categoryTitle = productData.category_title
    }

    this.subscription.add(
      // Here you can set your debounce time
      this.rxjsSimulator.pipe(debounceTime(1000)).subscribe((data) => {
        this.qytChange(
          data['product'],
          data['qyt'],
          data['template'],
          data['template2'],
          data['type']
        );
      })
    );

    this.routeChangeSubscriber$ = this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        this.previous_url = events[0].urlAfterRedirects;
        this.statePersist.setLocalStorage('previous_url', this.previous_url);
      });

    this.getBrandsListFromStore();

    this.activatedRoute.paramMap.subscribe((params) => {
      this.backButtonListHandling();
    });
  }

  async getBrandsListFromStore() {
    const config_store$ = await this.store.pipe(select(getBrands));
    this.getBrandsSubscirber$ = config_store$.subscribe((res) => {
      if (Object.keys(res).length) {
        if (this.brandSelected) {
          this.brandFilter = this.prioritizeSelectedBrand(
            [...res?.brandsList],
            this.brandSelected
          );
        } else {
          this.brandFilter = [...res?.brandsList];
        }
        this.categoryBrandsListing = this.homeService.groupBrands(
          res.brandsList
        );
        this.headerBrandsAlphabet = this.homeService.groupBrandsByAlpModal([
          ...res.brandsList,
          ...res?.topBrands,
        ]);
      }
    });
  }

  prioritizeSelectedBrand(brands, selectedId): Array<any> {
    if (!Array.isArray(brands)) return [];

    // Separate selected and others
    const selected = brands.find((b) => b.id === selectedId);
    const others = brands.filter((b) => b.id !== selectedId);

    // Sort others alphabetically by label
    others.sort((a, b) => a.label.localeCompare(b.label));

    // Return new array
    return selected ? [selected, ...others] : others;
  }

  backButtonListHandling() {
    let backListing;
    backListing = this.statePersist.getLocalStorage('back-to-product-listing');

    if (backListing != null && backListing) {
      this.statePersist.removeLocalStorage('back-to-product-listing');

      //----------------get the saved product filters--------------------
      this.productData = this.statePersist.getLocalStorage('product_data');

      this.topSeller = this.productData.top_seller;
      this.CatSort = this.productData.cat_sort;
      this.seasonal = this.productData.seasonal;
      this.new = this.productData.new;

      if (this.topSeller == '1') {
        this.topSellerValue = true;
      } else {
        this.topSellerValue = false;
      }
      let routeParams;

      routeParams = this.activatedRoute.snapshot.paramMap.get('categoryid');

      if (
        routeParams.includes('-') &&
        this.isNumeric(routeParams.split('-')[0])
      ) {
        this.categoryId = parseInt(routeParams.split('-')[0]);
      }

      this.searchText = this.productData.search_keyword;
      this.categoryTitle = this.productData.category_title;
      this.sortBy = this.productData.sort;
      this.order = this.productData.order;
      this.rspMin = this.productData.rsp_min;
      this.range = this.productData.range;
      this.rspMax = this.productData.rsp_max;
      this.brandSelected = this.productData.brand_filter;
      if (
        this.selectedPmpProductValue ||
        (this.productData && this.productData?.price_marked)
      ) {
        this.selectedPmpProductValue = parseInt(this.productData.price_marked);
      }
      this.promotionSelected = this.productData.promotion_filter;
      this.productList = [];
      this.nextPage = this.productData.page;
      this.totalProductCount = 0;
      this.totalProductPages = 1;
      this.page_number = this.productData.page;
      this.productListing('back_button');
    } else if (backListing != null && !backListing) {
      this.statePersist.removeLocalStorage('product_data');
    } else {
      this.page_number = '';
      this.productData = this.statePersist.getLocalStorage('product_data');

      this.rspMin = this.productData.rsp_min;
      this.rspMax = this.productData.rsp_max;
      this.range = this.productData.range;
      if (
        this.selectedPmpProductValue ||
        (this.productData && this.productData?.price_marked)
      ) {
        this.selectedPmpProductValue = this.productData.price_marked;
      }
      this.brandSelected = this.productData.brand_filter;

      if (
        this.productData &&
        this.productData.search_keyword != '' &&
        this.productData.search_keyword != undefined &&
        this.productData.search_keyword != null
      ) {
        this.searchText = this.productData.search_keyword;
        this.categoryTitle = this.productData.category_title;
      } else {
        this.searchText = '';
        this.categoryTitle = '';
      }

      if (
        this.promotionSelected ||
        (this.productData && this.productData.promotion_filter != '')
      ) {
        this.promotionSelected = this.productData.promotion_filter;
      } else {
        this.promotionSelected = '';
      }

      if (this.productData && this.productData.top_seller != '') {
        if (this.productData.top_seller == '1') {
          this.topSellerValue = true;
          this.topSeller = this.productData.top_seller;
        } else {
          this.topSellerValue = false;
          this.topSeller = '';
        }
      } else {
        this.topSellerValue = false;
        this.topSeller = '';
      }
      this.statePersist.watchCategoryMessage().subscribe((message) => {
        if (message == 'service') {
          this.categoryMessage = [];
        } else {
          if (message == '') {
            this.categoryMessage = [];
          } else {
            this.categoryMessage = message.split('|');
          }
        }
      });
      this.intitializeCall();
    }
  }

  toggleSideNav() {
    this.sideNavbar = !this.sideNavbar;
    if (this.sideNavbar) {
      document.body.classList.add('side-nav-open');
    } else {
      document.body.classList.remove('side-nav-open');
    }
  }

  popup(template: TemplateRef<any>) {
    this.bsModalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' })
    );
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth < 991;

    this.titleService.setTitle(ProductConsts.LISTING_TITLE);
    this.global_data = this.statePersist.getLocalStorage('global_data');

    this.getProductQuantityUpdateSubscirber$ = this.statePersist
      .watchProductPageStorage()
      .subscribe((message) => {
        if (message) {
          this.backButtonListHandling();
        }
      });

    this.watchGlobalDataSubscriber$ = this.statePersist
      .watchGlobalDataStorage()
      .subscribe((message) => {
        this.global_data = this.statePersist.getLocalStorage('global_data');
      });

    this.selectedStore = this.statePersist.getLocalStorage(
      'selectedStoreAddress'
    );
    this.miniCartDetails =
      this.statePersist.getLocalStorage('mini_cart_details');

    this.watchMiniCartSubscriber$ = this.statePersist
      .watchMiniCartDetailChange()
      .subscribe((message) => {
        this.miniCartDetails =
          this.statePersist.getLocalStorage('mini_cart_details');
      });

    this.watchCategorySubscriber$ = this.statePersist
      .watchCategoryMessage()
      .subscribe((message) => {
        if (message == 'service') {
          this.categoryMessage = [];
        } else {
          if (message == '') {
            message = [];
          }
          if (message == '') {
            this.categoryMessage = [];
          } else {
            this.categoryMessage = message.split('|');
          }
        }
      });
  }

  setBrandFilter(): void {
    if (this.activatedRoute.queryParams['_value']['brandId']) {
      this.brandSelected = this.activatedRoute.queryParams['_value']['brandId'];
    } else {
      this.brandSelected = '';
    }
    this.saveFilterToStorage('brand_filter', this.brandSelected);
  }

  saveFilterToStorage(keyName: string, value: any): void {
    let productData = JSON.parse(
      JSON.stringify(this.statePersist.getLocalStorage('product_data'))
    );
    productData[keyName] = value;

    this.statePersist.setLocalStorage('product_data', productData);
  }

  intitializeCall() {
    var routeParams;
    this.previous_url = this.statePersist.getLocalStorage('previous_url');
    this.categoryId = '';
    this.productList = [];
    this.nextPage = 1;
    routeParams = this.activatedRoute.snapshot.paramMap.get('categoryid');
    if (routeParams == 'All') {
      this.productList = [];
      this.nextPage = 1;
      this.totalProductCount = 0;
      this.totalProductPages = 1;
      this.seasonal = '0';
      this.new = '0';
      this.CatSort = '1';
      this.selectDataAsPerPerviousSelection();
      let promotion = this.promotionSelected;
      let brand = this.brandSelected;
      let pmpSelected = this.selectedPmpProductValue;
      if (
        this.previous_url != '' &&
        this.previous_url != null &&
        this.previous_url != undefined &&
        this.previous_url.includes('home')
      ) {
        this.promotionSelected = promotion;
        this.brandSelected = brand;
        this.selectedPmpProductValue = pmpSelected;
      }
      if (this.activatedRoute.queryParams['_value']['brandId']) {
        this.setBrandFilter();
      }
      this.productListing();
    } else if (routeParams == 'Seasonal') {
      this.seasonal = '1';
      this.new = '0';
      this.productList = [];
      this.nextPage = 1;
      this.totalProductCount = 0;
      this.totalProductPages = 1;
      this.CatSort = '';
      this.selectDataAsPerPerviousSelection();
      this.promotionSelected = '';
      this.brandSelected = '';
      if (this.activatedRoute.queryParams['_value']['brandId']) {
        this.setBrandFilter();
      }
      this.productListing();
    } else if (routeParams == 'New') {
      this.new = '1';
      this.seasonal = '0';
      this.productList = [];
      this.nextPage = 1;
      this.totalProductCount = 0;
      this.totalProductPages = 1;
      this.CatSort = '';
      this.selectDataAsPerPerviousSelection();
      this.promotionSelected = '';
      this.brandSelected = '';
      if (this.activatedRoute.queryParams['_value']['brandId']) {
        this.setBrandFilter();
      }
      this.productListing();
    } else if (
      routeParams.includes('-') &&
      this.isNumeric(routeParams.split('-')[0])
    ) {
      this.categoryId = parseInt(routeParams.split('-')[0]);
      this.productList = [];
      this.nextPage = 1;
      this.totalProductCount = 0;
      this.totalProductPages = 1;
      this.seasonal = '0';
      this.order = '';
      this.sortBy = '';
      this.new = '0';
      this.CatSort = '';
      this.selectDataAsPerPerviousSelection();
      this.promotionSelected = '';
      this.brandSelected = '';
      this.setBrandFilter();
      this.applyFilter();
    } else {
      this.productList = [];
      this.nextPage = 1;
      this.totalProductCount = 0;
      this.totalProductPages = 1;
    }
    this.statePersist.setLocalStorage('address-disabled', false);
    this.statePersist.setLocalStorage('retailer-disabled', false);
  }

  selectDataAsPerPerviousSelection(): void {
    this.productData = this.statePersist.getLocalStorage('product_data');
    if (this.productData.sort) {
      this.sortBy =
        this.productData?.sort == 'short_desc' || this.productData?.sort == ''
          ? 'short_desc'
          : this.productData?.sort;
    } else {
      this.sortBy = 'short_desc';
    }

    if (this.productData.order) {
      this.order =
        this.productData?.order == '' ? 'asc' : this.productData?.order;
    } else {
      this.order = 'asc';
    }
  }

  ngAfterViewInit() {
    if (this.menuElement != undefined) {
      this.elementPosition = this.menuElement.nativeElement.offsetTop;
    }

    this.getAllProductApiSubscribe = this.statePersist
      .watchStorage()
      .subscribe((message) => {
        this.productData = this.statePersist.getLocalStorage('product_data');
        this.topSeller = this.productData.top_seller;
        this.CatSort = this.productData.cat_sort;
        this.seasonal = this.productData.seasonal;
        this.new = this.productData.new;
        this.searchText = this.productData.search_keyword;
        this.categoryTitle = this.productData.category_title;
        this.productList = [];
        this.nextPage = 1;
        this.totalProductCount = 0;
        this.totalProductPages = 1;
        if (!this.getAllProductAlreadyCall) {
          this.productListing();
        }
      });
  }

  onFiltersChangedHandler(event: any): void {
    this.hasFiltersApplied = event.isFiltersApplied;
    this.nextPage = 1;
    if (event.isRefresh) {
      this.productListing('', true, event?.filterState);
    }

    this.appliedFilterObj = event?.filterState;

    if (event.isFiltercleared) {
      this.removeAllFilter();
    }

    if (event.isFiltercleared) {
      this.isFilterReset = true;
    } else {
      this.isFilterReset = false;
    }
  }

  removeAllFilter(): void {
    this.topSeller = '';
    this.topSellerValue = false;
    this.productList = [];
    this.nextPage = 1;
    this.totalProductCount = 0;
    this.totalProductPages = 1;
  }

  applyButtonEnableDisable() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    this.applyFilter();
  }
  selectTopSeller(event) {
    if (event.target.checked) {
      this.topSellerBeforeapplyValue = '1';
      this.topSellerValue = true;
    } else {
      this.topSellerValue = false;
      this.topSellerBeforeapplyValue = '0';
      this.filterSelected -= 1;
    }
    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PRODCAT_TOP_SELLER_FILTER_APPLIED_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PRODCAT_TOP_SELLER_FILTER_APPLIED_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );
    this.applyButtonEnableDisable();
  }

  redirectTo(sku) {
    var url = 'product/detail/' + sku;
    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PRODCAT_VIEW_PRODUCT_DETAILS_PLP_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PRODCAT_VIEW_PRODUCT_DETAILS_PLP_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );
    this.router.navigate([url]);
  }

  applyFilter() {
    if (
      (this.productData.rsp_min && this.productData?.rsp_min != '') ||
      (this.productData?.rsp_max && this.productData?.rsp_max != '')
    ) {
      this.rspMin = String(this.rspMinValue);
      this.rspMax = String(this.rspMaxValue);
    } else {
      this.rspMin = '';
      (this.rspMax = ''), (this.rspMinValue = 0);
      this.rspMaxValue = 5;
    }
    this.productList = [];
    this.nextPage = 1;
    this.totalProductCount = 0;
    this.totalProductPages = 1;
    if (this.activatedRoute.queryParams['_value']['brandId']) {
      this.setBrandFilter();
    }
    this.productListing();
  }

  // Product lisitng code
  isNumeric(value) {
    return this.constantsValues.NUMBER_PATTERN.test(value);
  }

  getFormDataValues(hasFiltersApplied: boolean = false, filterData?: any): any {
    let formdata = {
      top_seller: this.topSeller,
      range: this.range,
      price_marked: this.selectedPmpProductValue,
      cat_sort: this.CatSort,
      sort: this.sortBy,
      order: this.order,
      search_keyword: this.searchText,
      page_size: this.pageSize,
      seasonal: this.seasonal,
      new: this.new,
      cat_id: this.categoryId,
      page: this.nextPage,
      rsp_min: this.rspMin,
      rsp_max: this.rspMax,
      promotion_filter: this.promotionSelected,
      brand_filter: this.brandSelected,
      page_number: this.page_number,
    };
    if (hasFiltersApplied) {
      formdata = { ...formdata, ...filterData };

      return formdata;
    } else {
      return formdata;
    }
  }

  productListing(
    back?: any,
    hasFiltersApplied: boolean = false,
    filterData?: any,
    iscrollApplied: boolean = false
  ) {
    let payload: any = {};

    this.getAllProductAlreadyCall = true;
    this.selectDataAsPerPerviousSelection();

    if (this.hasFiltersApplied) {
      payload = { ...this.getFormDataValues(hasFiltersApplied, filterData) };
    } else {
      payload = { ...this.getFormDataValues(hasFiltersApplied) };
    }

    this.statePersist.setLocalStorage(
      'product_data',
      payload,
      'product-listing'
    );

    this.productService.getProducts(payload).subscribe((data) => {
      if (data.status == 1153) {
        this.noRecord = true;
        this.productList = [];
        this.nextPage = 1;
        if (this.searchText != '') {
          this.googleAnalyticsService.eventEmitter(
            SharedConsts.PRODCAT_SEARCH_RESULT_NOT_FOUND_EVENT,
            SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
            SharedConsts.PRODCAT_SEARCH_RESULT_NOT_FOUND_EVENT_ACTION,
            SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
            SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
          );
        }
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      } else {
        if (data.response) {
          if (this.searchText != '' && data.response.total_product_count > 0) {
            this.googleAnalyticsService.eventEmitter(
              SharedConsts.PRODCAT_SEARCH_RESULT_FOUND_PLP_EVENT,
              SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
              SharedConsts.PRODCAT_SEARCH_RESULT_FOUND_PLP_EVENT_ACTION,
              SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
              SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
            );
          }
          if (this.searchText != '' && data.response.total_product_count == 0) {
            this.googleAnalyticsService.eventEmitter(
              SharedConsts.PRODCAT_SEARCH_RESULT_NOT_FOUND_PLP_EVENT,
              SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
              SharedConsts.PRODCAT_SEARCH_RESULT_NOT_FOUND_EVENT_ACTION,
              SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
              SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
            );
          }
          this.filters = data.response.filters;
          let copy_page_number;
          copy_page_number = this.page_number;
          this.page_number = '';
          this.promotionFilter = this.filters.promotion_filters;
          if (this.filters.max_rsp != '' && this.filters.min_rsp != '') {
            this.rspMaxValue = parseFloat(this.filters.max_rsp);
            this.rspMinValue = parseFloat(this.filters.min_rsp);
          } else {
            this.rspMaxValue = parseFloat(this.rspMax);
            this.rspMinValue = parseFloat(this.rspMin);
          }

          var newoptions;
          newoptions = {};
          newoptions['floor'] = parseFloat(this.filters.min_rsp);
          newoptions['ceil'] = parseFloat(this.filters.max_rsp);
          newoptions['step'] = 0.01;
          this.options = newoptions;
          if (
            parseFloat(this.rspMax) == this.options['ceil'] &&
            parseFloat(this.rspMin) == this.options['floor']
          ) {
            this.rspMax = '';
            this.rspMin = '';
          }
          if (iscrollApplied) {
            this.productList = [...this.productList, ...data.response.products];
          } else {
            this.productList = [...data.response.products];
          }
          this.totalProductCount = data.response.total_product_count;
          this.totalProductPages = data.response.total_pages;
          let routeParams;
          routeParams = this.activatedRoute.snapshot.paramMap.get('categoryid');
          if (routeParams == 'All') {
            this.categoryName = 'All';
          } else if (routeParams == 'Seasonal') {
            this.categoryName = 'Seasonal';
          } else if (routeParams == 'New') {
            this.categoryName = 'New';
          } else {
            this.categoryName = data.response.main_category_name;
          }
          if (this.nextPage == 1) {
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'auto',
            });
          }
          if (this.totalProductPages < this.nextPage + 1) {
            this.nextPage = null;
          } else {
            this.nextPage += 1;
          }

          if (
            routeParams != 'All' &&
            data.response.total_product_count === 0 &&
            payload.search_keyword != '' &&
            payload.search_keyword != null &&
            payload.search_keyword != undefined
          ) {
            this.router.navigate(['product/listing/All']);
            this.statePersist.setLocalStorage('product_data', payload);
          } else if (data.response.total_product_count === 0) {
            this.noRecord = true;
            this.productList = [];
            this.nextPage = 1;
            this.totalProductCount = 0;
            this.totalProductPages = 1;
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth',
            });
          } else {
            this.noRecord = false;
          }
          setTimeout(() => {
            if (back) {
              let elemnetId;
              elemnetId =
                this.statePersist.getLocalStorage('scrollElementId') || '';
              if (elemnetId == '') {
                let elemntindex = (copy_page_number - 1) * this.pageSize;
                elemnetId = this.productList[elemntindex].sku;
              }
              let el = document.getElementById(
                'product_description_' + elemnetId
              );
              el.scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center',
              });

              this.statePersist.removeLocalStorage('scrollElementId');
            }
          }, 1000);
        }
      }
      this.contentLoaded = true;
      this.loading = false;
      this.getAllProductAlreadyCall = false;
    });
  }

  getAppliedTagsHandler(event: any): void {
    this.selectedBrandTagName = event?.brandTagName ? event?.brandTagName : '';
    this.selectedPmpTag = event?.pmpTagName ? event?.pmpTagName : '';
    this.selectedPromotionsTagName = event?.promotionTagName
      ? event?.promotionTagName
      : '';
  }

  onScrollDown() {
    if (this.nextPage != 1 && this.nextPage !== null && !this.loading) {
      this.loading = true;
      let filterObj = { ...this.appliedFilterObj, page: this.nextPage };
      if (this.hasFiltersApplied) {
        this.productListing('', true, filterObj, true);
      } else {
        this.productListing('', false, filterObj, true);
      }
    }
  }

  toInteger(value) {
    return parseInt(value);
  }
  addToCart(
    product,
    qyt,
    template: any,
    type: any,
    template2: any,
    popup_24hr_template: any,
    check_last_order = true
  ) {
    this.googleAnalyticsService.eventEmitter(
      SharedConsts.PRODCAT_ADDTOCART_PLP_EVENT,
      SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,
      SharedConsts.PRODCAT_ADDTOCART_PLP_EVENT_ACTION,
      SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL,
      SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE
    );
    let dataObj;
    if (product.qty == '') {
      qyt = '1';
    }

    if (!check_last_order) {
      this.bsModalRef.hide();
    }

    this.miniCartDetails =
      this.statePersist.getLocalStorage('mini_cart_details');
    if (this.miniCartDetails) {
      if (
        this.miniCartDetails.items_count != '0' &&
        this.miniCartDetails.items_count != ''
      ) {
        check_last_order = false;
      }
    }

    dataObj = {
      cart_item: {
        sku: product.sku,
        qty: qyt,
      },
      check_last_order: check_last_order,
    };

    this.productService.addToCart(dataObj).subscribe((data) => {
      if (data.response) {
        this.popupMessage = '';
        if (data.status == 2212) {
          for (let i = 0; i < this.productList.length; i++) {
            if (this.productList[i]['product_id'] == product.product_id) {
              this.productList[i]['qty'] = '1';
            }
          }
          this.alertService.error(data.response.msg);
        } else if (data.status == 1169) {
          for (let i = 0; i < this.productList.length; i++) {
            if (this.productList[i]['product_id'] == product.product_id) {
              this.productList[i]['qty'] = '1';
              this.productList[i]['back_in_stock'] = '0';
            }
          }
        } else if (data.status == 1180) {
          localStorage.setItem('closeStorInfoMessage', data.response.msg);
          document.getElementById('openclosedStoreInfo').click();
          for (let i = 0; i < this.productList.length; i++) {
            if (this.productList[i]['product_id'] == product.product_id) {
              this.productList[i]['qty'] = '1';
            }
          }
        } else if (data.status == 1168) {
          for (let i = 0; i < this.productList.length; i++) {
            if (this.productList[i]['product_id'] == product.product_id) {
              this.productList[i]['qty'] = '1';
              this.productList[i]['back_in_stock'] = '0';
            }
          }
          this.popupMessage = data.response;
          this.commonBottonText = "Ok, Don't show this again";
          this.popup(template2);
        } else if (data.status == 1163) {
          this.alertService.error(data.response);
          this.productList = this.productList.filter(
            (item) => item.product_id !== product.product_id
          );
        } else if (data.status == 1188) {
          this.product_for_24_hr = product;

          this.popupMessage = data.response.split('<br>').join('\n');
          this.commonBottonText = 'Confirm';
          this.popup(popup_24hr_template);
        } else {
          for (let i = 0; i < this.productList.length; i++) {
            if (this.productList[i]['product_id'] == product.product_id) {
              this.productList[i]['qty'] = String(qyt);
              this.productList[i]['item_id'] = data.response.item_id;
            }
          }
          var storeCount;
          this.selectedStore = this.statePersist.getLocalStorage(
            'selectedStoreAddress'
          );
          storeCount = this.statePersist.getLocalStorage(
            'selectedStoreAddress'
          );
          if (template && storeCount['totalStoreCount'] > 1) {
            this.popup(template);
          }
        }
        this.statePersist.emitminiCartData('min cart update');
      }
    });
    // Set boolean class on click of add button
  }
  public send(product, qyt, template, template2: any, type: any): void {
    // uses an ever-changing value in order to always trigger the update
    this.rxjsSimulator.next({
      product: product,
      qyt: qyt,
      template: template,
      template2: template2,
      type: type,
    });
  }
  qytChange(product, qyt, template, template2: any, type: any) {
    this.statePersist.amendQtyGoogleanalyticsEvent();
    if (product.item_id !== '') {
      if (qyt == 0) {
        for (let i = 0; i < this.productList.length; i++) {
          if (this.productList[i]['product_id'] == product.product_id) {
            this.productList[i]['qty'] = 0;
          }
        }
        this.removeItem(product);
      } else {
        this.qytUpdate(product, String(qyt), template);
      }
    } else {
      for (let i = 0; i < this.productList.length; i++) {
        if (this.productList[i]['product_id'] == product.product_id) {
          this.productList[i]['qty'] = String(qyt);
        }
      }
    }
  }

  qytUpdate(product, qyt, template) {
    this.productService
      .qytUpdate({ item_id: parseInt(product.item_id), qty: qyt })
      .subscribe((data) => {
        if (data.response) {
          this.popupMessage = '';
          if (data.status == 1169) {
            for (let i = 0; i < this.productList.length; i++) {
              if (this.productList[i]['product_id'] == product.product_id) {
                this.productList[i]['qty'] = '1';
                this.productList[i]['item_id'] = '';
                this.productList[i]['back_in_stock'] = '0';
              }
            }
          } else if (data.status == 2211) {
            this.alertService.error(data.response);
            this.productList = [];
            this.nextPage = 1;
            this.totalProductCount = 0;
            this.totalProductPages = 1;

            this.productListing();
          } else if (data.status == 2212) {
            this.alertService.error(data.response);
            for (let i = 0; i < this.productList.length; i++) {
              if (this.productList[i]['product_id'] == product.product_id) {
                this.productList[i]['qty'] = data.response.qty;
              }
            }
          } else if (data.status == 1180) {
            for (let i = 0; i < this.productList.length; i++) {
              if (this.productList[i]['product_id'] == product.product_id) {
                this.productList[i]['qty'] = String(data.response.qty);
              }
            }

            localStorage.setItem('closeStorInfoMessage', data.response.msg);
            document.getElementById('openclosedStoreInfo').click();
            const currentUrl = this.router.url;
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([currentUrl]);
              });
          } else if (data.status == 1163) {
            this.alertService.error(data.response);
            this.productList = this.productList.filter(
              (item) => item.product_id !== product.product_id
            );
          } else {
            for (let i = 0; i < this.productList.length; i++) {
              if (this.productList[i]['product_id'] == product.product_id) {
                this.productList[i]['qty'] = qyt;
              }
            }
          }
          this.statePersist.emitminiCartData('min cart update');
        }
      });
  }

  removePopup(template: TemplateRef<any>, selectedProduct) {
    this.removeProduct = selectedProduct;
    this.removeHeading = 'Are you sure you want to remove product from cart?';
    this.bsModalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' })
    );
  }

  removeItem(product) {
    let fordata;
    fordata = { item_id: product.item_id };
    this.cartService.removeItem(fordata).subscribe((data) => {
      if (data.response) {
        if (data.status == 1180) {
          localStorage.setItem('closeStorInfoMessage', data.response.msg);
          document.getElementById('openclosedStoreInfo').click();
          const currentUrl = this.router.url;
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([currentUrl]);
            });
        } else if (data.status == 2212) {
          this.alertService.error(data.response);
        } else if (data.status == 2211) {
          this.alertService.error(data.response);
          this.productList = [];
          this.nextPage = 1;
          this.totalProductCount = 0;
          this.totalProductPages = 1;
          this.productListing();
        } else {
          for (let i = 0; i < this.productList.length; i++) {
            if (this.productList[i]['product_id'] == product.product_id) {
              this.productList[i]['back_in_stock'] = '';
              this.productList[i]['item_id'] = '';
            }
          }
          this.statePersist.emitminiCartData('update mini cart');
          this.alertService.success('Product removed.');
        }
      }
    });
  }

  onRemovePmpFilter(pmpId: any): void {
    this.sideBarComponent && this.sideBarComponent.onSelectPmp(pmpId);
  }

  onRemoveTitle() {
    this.categoryTitle = '';
    this.searchText = '';
    this.productData = this.statePersist.getLocalStorage('product_data')
    this.productData.search_keyword = '';
    this.productData.category_title = '';
    this.statePersist.setLocalStorage('product_data', {'search_keyword':'', 'category_title':''} , 'search')
  }

  onRemoveBrandFilter(): void {
    this.sideBarComponent &&
      this.sideBarComponent.resetQueryParamsForAppliedBrandFilter();
  }

  onRemovePromotionsFilter(promotionsId: any, promotionsName: any): void {
    this.sideBarComponent &&
      this.sideBarComponent.onSelectPromotion(promotionsId, promotionsName);
  }

  openModalbrands() {
    const initialState: ModalOptions = {
      initialState: {
        brandsList: this.categoryBrandsListing,
        selectedBrandId: this.brandSelected,
        headerBrandsAlphabet: this.headerBrandsAlphabet,
        isScreenProductCatalogue: true,
        categoryId: this.activatedRoute.snapshot.paramMap.get('categoryid'),
        originalBrandListing: JSON.parse(
          JSON.stringify(this.categoryBrandsListing)
        ),
      },
      backdrop: 'static',
      class: 'modal-lg-brands',
    };

    this.modalRef = this.modalService.show(BrandModalComponent, initialState);
  }

  ngOnDestroy() {
    if (this.getAllProductApiSubscribe) {
      this.getAllProductApiSubscribe.unsubscribe();
    }
    this.getProductQuantityUpdateSubscirber$?.unsubscribe();
    this.routeChangeSubscriber$?.unsubscribe();
    this.watchGlobalDataSubscriber$?.unsubscribe();
    this.watchMiniCartSubscriber$?.unsubscribe();
    this.watchCategorySubscriber$?.unsubscribe();
    localStorage.removeItem('promotion_tag_name');
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= this.elementPosition) {
      this.sticky = false;
    } else {
      this.sticky = true;
    }
  }

  filterMobile(modal: any) {
    this.modalService.show(modal);
  }

  openAccordionFullscreen() {
    this.filterMobileview = true;
  }

  getCalculatedMargin(product: any){
    return this.sharedService.getStoreVatFreeMargin(product)
  }
}
